import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { ErrorDialogService } from '../../shared/error-dialog/error-dialog.service';
import { AuthorizationError } from '../../models/errors/error.model';

@Component({
    selector: 'app-bootstrap',
    templateUrl: './bootstrap.component.html',
    styleUrls: ['./bootstrap.component.scss'],
    standalone: false
})
export class BootstrapComponent implements OnInit {
    submitting = false;
    public form: UntypedFormGroup;

    constructor(
    private authService: AuthService,
    public errorDialog: ErrorDialogService,
    public router: Router
    ) { }

    async ngOnInit() {
        // redirect to an external url:
        await this.authService.bootstrapSession()
        .then(() => {
            console.log('OnInit: bootstrap session successful');
            this.authService.redirectAfterLogin();
        })
        .catch(async (err) => {
            if (err instanceof AuthorizationError) {
                this.authService.redirectToSuiteSignIn();
                return;
            }
            await this.authService.sessionExpired();
        });
    }

}